<template>
  <form-container :title="stageTitle">

    <form-incident-type @incident-type-selected="handleTypeClick"></form-incident-type>
      <br>
      <br>
      
      <div ref="prevClaims">

        <label class="headings">Have you made a claim for any gadget within the last 2 years?</label>
        <div class="radio-style-xx">
            <input id="previousYes" name="previous" type="radio" v-model="otherClaims" :value="true" >
            <label for="previousYes">Yes</label>
        </div>
        <div class="radio-style-xx">
            <input id="previousNo" name="previous" type="radio" v-model="otherClaims" :value="false">
            <label for="previousNo">No</label>
        </div>
        
        <div name="otherclaims" :class="otherClaimsClass">{{ this.nextAttempted && !this.isOtherClaimsValid ? 'Please indicate whether you have made any previous gadget claims' : '' }}</div>
        <div class="bumper"></div>
        <transition name="fade">
        <div v-show="otherClaims === true">
          
        <label for="otherClaimsGadgetDetails">Gadget details</label>
          <input type="text" 
                 id="otherClaimsGadgetDetails" 
                 fieldlabel="otherClaimsGadgetDetails" 
                 class="form-control form-control-lg"
                 v-model="otherClaimsGadgetDetails">
          <div :class="otherClaimsGadgetDetailsClass">{{ this.nextAttempted && !this.isOtherClaimsGadgetDetailsValid ? 'Please provide details of the gadget(s) claimed for' : ''}}</div>

          <label for="otherClaimsCompanyName">Company name</label>
          <input type="text" 
                 id="otherClaimsCompanyName" 
                 fieldlabel="otherClaimsCompanyName"
                 class="form-control form-control-lg" 
                 v-model="otherClaimsCompanyName">
          <div  :class="otherClaimsCompanyNameClass">{{ this.nextAttempted && !this.isOtherClaimsCompanyNameValid ? 'Please provide the name of the company who you claimed through' : ''}}</div>
          <label for="otherClaimsOutcome">Claim outcome</label>
          <input type="text" 
                 id="otherClaimsOutcome" 
                 fieldlabel="otherClaimsOutcome"
                 class="form-control form-control-lg" 
                 v-model="otherClaimsOutcome">
          <div  :class="otherClaimsOutcomeClass">{{ this.nextAttempted && !this.isOtherClaimsOutcomeValid ? 'Please provide the outcome of your claim' : ''}}</div>
          
        </div>
        </transition>
      </div>
      <br>
      <form-button-bar
            :back_button_show='false'
            :next_button_enable='true'
            :next_button_show='true'
            :next_button_icon_enable='true'
            
            :next_button_action='handleNextClick' />
  </form-container>
</template>

<script>
import tigaClaimForm from "@/mixins/tigaClaimForm";
import FormContainer from '@/components/FormContainer.vue'
import FormIncidentType from '@/components/FormIncidentType.vue'
import { smoothScrollTo } from "@/util/smoothScroll.js";
import selectableCard from "@/components/standaloneForm/SelectableCard";
import FormButtonBar from '@/components/standaloneForm/FormButtonBar.vue'

export default {
  name: "incidentTypes",
  props: {
    value: {
      required: false
    }
  },
  components: {
    FormContainer,
    FormIncidentType,
    selectableCard,
    FormButtonBar
  },
  mixins: [tigaClaimForm],
  data() {
    return {
      incidentTypes: [
        {
          id: 1000,
          level: 1,
          parentId: null,
          label: "Accidental damage",
          icon: "fas fa-band-aid",
          children: [
            {
              id: 1004,
              level: 2,
              parentId: 1000,
              label: "Impact damage",
              icon: "fas fa-compress"
            },
            {
              id: 1005,
              level: 2,
              parentId: 1000,
              label: "Liquid damage",
              icon: "fas fa-tint"
            },
            {
              id: 1006,
              level: 2,
              parentId: 1000,
              label: "Other",
              icon: "fas fa-question-circle"
            }
          ]
        },
        {
          id: 1001,
          level: 1,
          parentId: null,
          label: "Theft",
          icon: "fas fa-user-secret",
          children: [
            {
              id: 1007,
              level: 2,
              parentId: 1001,
              label: "At home",
              icon: "fab fa-houzz"
            },
            {
              id: 1008,
              level: 2,
              parentId: 1001,
              label: "At work",
              icon: "fas fa-industry"
            },
            {
              id: 1009,
              level: 2,
              parentId: 1001,
              label: "In a public place",
              icon: "fas fa-users"
            },
            {
              id: 1010,
              level: 2,
              parentId: 1001,
              label: "On public transport",
              icon: "fas fa-bus"
            }
          ]
        },
        {
          id: 1002,
          level: 1,
          parentId: null,
          label: "Loss",
          icon: "fas fa-question-circle",
          children: [
            {
              id: 1011,
              level: 2,
              parentId: 1002,
              label: "At home",
              icon: "fab fa-houzz"
            },
            {
              id: 1012,
              level: 2,
              parentId: 1002,
              label: "At work",
              icon: "fas fa-industry"
            },
            {
              id: 1013,
              level: 2,
              parentId: 1002,
              label: "In a public place",
              icon: "fas fa-users"
            },
            {
              id: 1014,
              level: 2,
              parentId: 1002,
              label: "On public transport",
              icon: "fas fa-bus"
            }
          ]
        },
        {
          id: 1003,
          level: 1,
          parentId: null,
          label: "Mechanical breakdown",
          icon: "fas fa-wrench"
        }
      ],

      selectedIncidentType: null,
      selectedIncidentTypeChild: null,
      nextAttempted: false
    };
  },
  watch: {},
  computed: {
    otherClaims: {
      get() {
        return this.$store.state.claimform.claimForm.data.otherClaims;
      },
      set(value) {
        this.$store.commit("claimform/setOtherClaims", { otherClaims: value });
        if (value === false) {
          this.otherClaimsGadgetDetails = null
          this.otherClaimsCompanyName = null
          this.otherClaimsOutcome = null
        }
      }
    },
    otherClaimsGadgetDetails: {
      get() {
        return this.$store.state.claimform.claimForm.data.otherClaimsGadgetDetails;
      },
      set(value) {
        this.$store.commit("claimform/setOtherClaimsGadgetDetails", value );
      }
    },
    otherClaimsCompanyName: {
      get() {
        return this.$store.state.claimform.claimForm.data.otherClaimsCompanyName;
      },
      set(value) {
        this.$store.commit("claimform/setOtherClaimsCompanyName", value);
      }
    },
    otherClaimsOutcome: {
      get() {
        return this.$store.state.claimform.claimForm.data.otherClaimsOutcome;
      },
      set(value) {
        this.$store.commit("claimform/setOtherClaimsOutcome",value);
      }
    },
    isOtherClaimsValid() {
      return this.otherClaims != null;
    },
    isOtherClaimsGadgetDetailsValid() {
      if (this.otherClaims === true) {
        return this.otherClaimsGadgetDetails !== null && typeof this.otherClaimsGadgetDetails !== 'undefined'
      }
      return true
    },
    isOtherClaimsCompanyNameValid() {
      if (this.otherClaims === true) {
        return this.otherClaimsCompanyName !== null && typeof this.otherClaimsCompanyName !== 'undefined'
      }
      return true
    },
    isOtherClaimsOutcomeValid() {
      if (this.otherClaims === true) {
        return this.otherClaimsOutcome !== null && typeof this.otherClaimsOutcome !== 'undefined'
      }
      return true
    },
    isIncidentTypeValid() {
      return this.selectedIncidentType != null;
    },
    selectedIncidentTypeHasChildren() {
      if (this.selectedIncidentType) {
        return (
          this.selectedIncidentType.children &&
          this.selectedIncidentType.children.length > 0
        );
      }
      return false;
    },
    isIncidentTypeChildValid() {
      return this.selectedIncidentTypeChild != null;
    },
    isFormValid() {
      if (!this.isIncidentTypeValid) {
        return false;
      }
      if (this.selectedIncidentTypeHasChildren) {
        if (!this.isIncidentTypeChildValid) {
          return false;
        }
      }
      if (!this.isOtherClaimsValid) {
        return false;
      }
      if (this.otherClaims === true) {
        if (!this.isOtherClaimsGadgetDetailsValid) {
          return false;
        }
        if (!this.isOtherClaimsCompanyNameValid) {
          return false;
        }
        if (!this.isOtherClaimsOutcomeValid) {
          return false;
        }
      }
      return true;
    },
    incidentTypeClass() {
      let klass = {}
      //klass['invalid-feedback'] = true;
      klass['invalid-feedback d-block'] = this.nextAttempted && !this.isIncidentTypeValid;
      return klass
    },
    incidentTypeChildClass() {
      // "nextAttempted && (!isIncidentTypeChildValid & selectedIncidentTypeHasChildren)"
      let klass = {}
      //klass['invalid-feedback'] = true
      klass['invalid-feedback d-block'] = this.nextAttempted && (!this.isIncidentTypeChildValid & this.selectedIncidentTypeHasChildren)
      return klass
    },
    otherClaimsClass() {
      let klass = {}
      //klass['invalid-feedback'] = true
      klass['invalid-feedback d-block'] = this.nextAttempted && !this.isOtherClaimsValid
      return klass
    },
    otherClaimsGadgetDetailsClass() {
      let klass = {}
      //klass['invalid-feedback'] = true
      klass['invalid-feedback d-block'] = this.nextAttempted && !this.isOtherClaimsGadgetDetailsValid
      return klass
    },
    otherClaimsCompanyNameClass() {
      let klass = {}
      //klass['invalid-feedback'] = true
      klass['invalid-feedback d-block'] = this.nextAttempted && !this.isOtherClaimsCompanyNameValid
      return klass
    },
    otherClaimsOutcomeClass() {
      let klass = {}
      //klass['invalid-feedback'] = true
      klass['invalid-feedback d-block'] = this.nextAttempted && !this.isOtherClaimsOutcomeValid
      return klass
    },
    stageTitle() {
      return this.$textManager.getText("title", this.$route.name)
    }
  },
  methods: {
    scrollTo(ref) {
      smoothScrollTo(window, this.$refs[ref], 0, 500);
    },
    getCardClass(selectedType, type) {
      if (selectedType) {
        return selectedType.id == type.id
          ? "incident-card-selected incident-card"
          : "incident-card";
      }

      return "incident-card";
    },
    handleTypeClick(type) {
      this.selectedIncidentType = type;
      this.setSelectedIncidentType(type);
      this.selectedIncidentTypeChild = null;
      this.scrollTo("childTypes");
    },
    handleTypeChildClick(type) {
      this.selectedIncidentTypeChild = type;
      this.setSelectedIncidentType(type);
      this.scrollTo("prevClaims");
    },
    handleNextClick() {
      const checkForm = this.checkForm()
      this.nextAttempted = true;
      if (this.isFormValid && checkForm) {
        this.$router.push({ path: "6" });
      }
    }
  },
  mounted () {
    if (!this.claimformHasPolicyNumber || !this.claimformHasClaimant) {
      this.gotoStage1();
    }
  },
};
</script>

